import React from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBrandsProps, IconRender } from '../types.ts';

const Passendo = React.forwardRef<SVGSVGElement | null, IconBrandsProps>(function Passendo({ colored, dataTestId, ...props }, ref) {
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = React.useCallback<IconRender>(
    (color: string) => (
      <>
        {/* default */}
        <path
          d='M12 3C16.5563 3 20.25 6.69365 20.25 11.25C20.25 14.0415 18.8621 16.5072 16.7402 18H21.5C21.7761 18 22 18.2239 22 18.5V19C22 19.2761 21.7761 19.5 21.5 19.5H2.5C2.22386 19.5 2 19.2761 2 19V18.5C2 18.2239 2.22386 18 2.5 18H7.25977C5.1379 16.5072 3.75 14.0415 3.75 11.25C3.75 6.69365 7.44365 3 12 3ZM12 4.5C8.27208 4.5 5.25 7.52208 5.25 11.25C5.25 14.9779 8.27208 18 12 18C15.7279 18 18.75 14.9779 18.75 11.25C18.75 7.52208 15.7279 4.5 12 4.5Z'
          fill={colored ? 'transparent' : color}
        />
        {/* colored */}
        <path
          d='M21.5 18C21.7761 18 22 18.2239 22 18.5V19C22 19.2761 21.7761 19.5 21.5 19.5H12V18H21.5Z'
          fill={colored ? '#422E93' : 'transparent'}
        />
        <path
          d='M18.75 11.25C18.75 7.52208 15.7279 4.5 12 4.5C8.27208 4.5 5.25 7.52208 5.25 11.25C5.25 14.9779 8.27208 18 12 18C15.7279 18 18.75 14.9779 18.75 11.25ZM20.25 11.25C20.25 15.8063 16.5563 19.5 12 19.5C7.44365 19.5 3.75 15.8063 3.75 11.25C3.75 6.69365 7.44365 3 12 3C16.5563 3 20.25 6.69365 20.25 11.25Z'
          fill={colored ? 'url(#gradient)' : 'transparent'}
        />
        <path
          d='M12 18V19.5H2.5C2.22386 19.5 2 19.2761 2 19V18.5C2 18.2239 2.22386 18 2.5 18H12Z'
          fill={colored ? '#8183FF' : 'transparent'}
        />
        <defs>
          <radialGradient id='gradient' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='rotate(90) scale(20)'>
            <stop offset='0%' stopColor='#422E93' />
            <stop offset='100%' stopColor='#8183FF' />
          </radialGradient>
        </defs>
      </>
    ),
    [colored],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'passendo-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Passendo;
